// extracted by mini-css-extract-plugin
export default {"tokenPanel":"qExbS"};